import React from 'react';
import { TouchableOpacity, View } from 'react-native-web';
import { Icon_str } from '../../../utils/DictionaryManagementUtils';
import IconText from '../Text/IconText';

//= ========================================================================

const SquareInBar = ({ isSelected, onPress }) => {
  const myStyles = {
    bottom: {
      height: 50,
      width: 150,
      marginEnd: 12,
      padding: isSelected ? 0 : 1,
      borderRadius: 6,
      border: isSelected ? 'solid 2px #008cff' : 'solid 0.6px #cbd5e0',
      boxShadow: '0 0 10px 0 rgba(0, 109, 199, 0.12)',
    },
    square: {
      height: isSelected ? 46 : 48,
      width: 48,
      borderRadius: 6,
      border: 'dashed 1px #cbd5e0',
      backgroundColor: '#f7fafc',
    },
  };
  return (
    <TouchableOpacity
      style={myStyles.bottom}
      onPress={onPress}
    >
      <View style={myStyles.square}>
        <IconText>{Icon_str}</IconText>
      </View>
    </TouchableOpacity>
  );
};
export default SquareInBar;
